/* eslint-disable no-await-in-loop */

export const KEYS = {
  CRM: "CRM",
  GEFINTECH: "GEFINTECH",
  GEFINTECH_INVOICES: "GEFINTECH_INVOICES",
}

export const getValidUrl = (settings: $TSMigrationFixMe) => {
  return {
    GEFINTECH: {
      key: "GEFINTECH",
      url: import.meta.env.REACT_APP_SHARED_POINT_OPS,
      logo: settings.opsIsotipo,
    },
    GEFINTECH_INVOICES: {
      key: "GEFINTECH_INVOICES",
      url: import.meta.env.REACT_APP_SHARED_POINT_OPS_INVOICES,
      logo: settings.opsIsotipo,
    },
  }
}

export const initFakeProgress = async (setProgressValue: $TSMigrationFixMe) => {
  for (let i = 10; i <= 100; i += 10) {
    await new Promise((res) => setTimeout(res, 100))
    setProgressValue(i)
  }
  await new Promise((res) => setTimeout(res, 1000))
}

export const getDataToSendToExternalApp = (
  empresaActiva: $TSMigrationFixMe,
  firstName: $TSMigrationFixMe,
  setShowLoader: $TSMigrationFixMe,
  setInitProgressValue: $TSMigrationFixMe,
  setMessage: $TSMigrationFixMe,
  setProgressValue: $TSMigrationFixMe,
  aplicationKey: $TSMigrationFixMe
) => {
  // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
  localStorage.setItem("mercado-facturas-first-time", true)

  const configMdfConnector = {
    action: "set",
    rowData: empresaActiva,
    firstName,
    token: sessionStorage.getItem("access_token"),
    refreshToken: sessionStorage.getItem("refresh_token"),
    comesFromVuzoon: true,
  }
  setShowLoader(true)
  setInitProgressValue(true)
  setMessage(JSON.stringify(configMdfConnector))
  initFakeProgress(setProgressValue).then(() => {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
    window.open(getValidUrl(configMdfConnector)[aplicationKey].url, "_self")
    sessionStorage.clear()
    localStorage.clear()
  })
}
